/**
 * Returns the unformatted value of a currency
 * @param {string} value - The value to be unformatted
 * @param {options} param1 - The options for unformatting the value
 * @returns {string}
 */
export const getUnformattedValue = function (value) {
  let {
    allowDecimals
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!value) {
    return '';
  }
  if (allowDecimals && value.indexOf('.') > -1) {
    let unformattedValue = value.replace(/[^0-9.]/g, '').split('.');
    return unformattedValue[0] + '.' + unformattedValue[1].substring(0, 2);
  } else {
    return value.replace(/\D/g, '');
  }
};

/**
 * Formats a value as currency
 * @param {string} unformattedValue - The value to be formatted as currency
 * @param {Object} options
 * @returns {string}
 */
export const getFormattedValue = function (unformattedValue) {
  let {
    allowDecimals,
    currencySymbol = '$'
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (undefined === unformattedValue || unformattedValue === '') {
    return '';
  }
  const currencyParts = unformattedValue.split('.');
  const dollarsPart = Number(currencyParts[0]).toString();
  const centsPart = currencyParts[1];
  let formattedDollars = '';
  let formattedCents = '';
  if (allowDecimals && unformattedValue.indexOf('.') > -1) {
    formattedCents = '.' + (centsPart + '00').substring(0, 2);
  } else if (allowDecimals) {
    formattedCents = '.00';
  }
  if (dollarsPart === '') {
    formattedDollars = '0';
  } else if (dollarsPart.length < 3) {
    formattedDollars = dollarsPart;
  } else {
    const leadingNumberCount = dollarsPart.length % 3;
    if (leadingNumberCount !== 0) {
      formattedDollars = dollarsPart.substring(0, leadingNumberCount) + ',';
    }
    formattedDollars = formattedDollars + dollarsPart.substring(leadingNumberCount).replace(/(\d{3})(?=\d)/g, '$1' + ',');
  }
  return currencySymbol + formattedDollars + formattedCents;
};